import getClients from '@providers/apollo/getClients'

import {OrionApolloClient} from './createApolloClient/orion'

export default function getClient(clientName = 'main'): OrionApolloClient<any> {
  const clients = getClients()
  return clients[clientName]
}
